import ApiService from '@/services/api.service'

const EmployeeCredentialService = {
    getAll(parameter){
        const requestData = {
            method: 'get',
            url: "/employeecredentials/",       
            params: {
              SearchCriteria: parameter.SearchCriteria,
              PageSize: parameter.PageSize,
              PageNumber: parameter.PageNumber,  
            }
          }       
          return ApiService.customRequest(requestData);
    }, 
    Add(data){
        return ApiService.post(`/employeecredentials`, data);
    },
    Delete(Id){      
        return ApiService.delete(`/employeecredentials/${Id}`);
    },
    Update(Id,data){
        return ApiService.put(`/employeecredentials/${Id}`,data);
    },   
    Get(Id){     
        return ApiService.get(`/employeecredentials/${Id}`);
    },
    getEmployeeCredentialByCode(parameter){
      const requestData = {
        method: 'get',
        url: "/employeecredentials/",
        headers: {
        },
        params: {          
          code: parameter.code           
        }
      }     
      return ApiService.customRequest(requestData);       
    },
  }


  
  export default EmployeeCredentialService;